/** Uses the configured asset base, defaulting to the shared, manually managed CDN folder. */
export function assetUrl(path: string): string {
  const value = (path ?? '').trim();

  if (!value) {
    return '';
  }

  if (/^(?:[a-z]+:)?\/\//i.test(value) || value.startsWith('data:')) {
    return value;
  }

  const normalizedPath = value.startsWith('/') ? value : `/${value}`;
  const base = (import.meta.env.VITE_ASSET_BASE_URL?.trim() || 'https://assets.erank.com/production').replace(/\/+$/, '');

  return `${base}${normalizedPath}`;
}
